import { FilterExprSchema } from '@hostingportal/schemas'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { PANEL_TYPES } from '../../../shell/panel-state'
// Register the deal panel plus the foreign panels the deals grid cross-references
// (company / contact) so those open in place without leaving the deals list.
import '../../../modules/companies/register-panels'
import '../../../modules/contacts/register-panels'
import '../../../modules/deals/register-panels'
import { DealsView } from '../../../modules/deals/deals-view'

const dealsSearchSchema = z.object({
  q: z.string().optional(),
  view: z.enum(['table', 'board']).optional(),
  page: z.coerce.number().int().min(1).optional(),
  pageSize: z.coerce.number().int().min(1).max(200).optional(),
  panel: z.enum(PANEL_TYPES).optional(),
  panelId: z.string().optional(),
  panelMode: z.enum(['create']).optional(),
  companyId: z.string().optional(),
  sortField: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
  // AND/OR filter expression (table view, Zod-validated).
  filter: FilterExprSchema.optional(),
  // Quick-filter values (the top-bar chips), URL-backed + Zod-validated.
  quick: FilterExprSchema.optional(),
})

/** The deals surface: a pipeline board + a table, both over the 7 stages. */
export const Route = createFileRoute('/_authed/deals/')({
  validateSearch: dealsSearchSchema,
  component: DealsRoute,
})

function DealsRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  return (
    <DealsView
      search={search}
      setSearch={(patch) =>
        navigate({
          to: '.',
          search: ((prev: Record<string, unknown>) => ({ ...prev, ...patch })) as never,
          replace: true,
        })
      }
    />
  )
}
